import {
  MeUser,
  UserServiceRole,
  UserAccount,
  DefaultRoles,
  ClientAccount,
} from '@banzai/data/auth';

export interface ValidateAccountResult {
  account?: UserAccount;
  shouldRedirect: boolean;
  hasAccountForService: boolean;
  role?: UserServiceRole;
  hasUser: boolean;
  fromBanzaiService: boolean;
}

export function validateAccount(
  service_id: string,
  existingAccount: ClientAccount | undefined,
  user: MeUser | undefined
): ValidateAccountResult {
  if (!user) {
    return {
      hasUser: false,
      shouldRedirect: true,
      hasAccountForService: false,
      fromBanzaiService: false,
    };
  }

  let foundAccount;
  let foundRole;

  if (existingAccount) {
    foundAccount = user.accounts.find(x => x.account.account_id === existingAccount.account_id);

    foundRole = foundAccount?.roles.find(x => x.service_id === service_id);

    if (foundAccount && foundRole) {
      return {
        hasUser: true,
        account: foundAccount,
        shouldRedirect: false,
        hasAccountForService: true,
        role: foundRole,
        fromBanzaiService: false,
      };
    }
  }

  const banzaiRoleForService = user.banzaiRoles.find(x => x.service_id === service_id);

  if (banzaiRoleForService && existingAccount) {
    return {
      hasUser: true,
      fromBanzaiService: true,
      shouldRedirect: false,
      hasAccountForService: false,
      role: {
        name: banzaiRoleForService.name as DefaultRoles,
        service_id: service_id,
        service: {
          name: service_id,
          service_id: service_id,
          url: '',
        },
      },
      account: {
        roles: [],
        account: existingAccount,
      },
    };
  }

  foundAccount = user.accounts.find(x => x.roles.find(y => y.service_id === service_id));
  foundRole = foundAccount?.roles.find(x => x.service_id === service_id);
  if (!foundAccount) {
    return {
      hasUser: true,
      shouldRedirect: true,
      hasAccountForService: false,
      fromBanzaiService: false,
    };
  }

  return {
    hasUser: true,
    shouldRedirect: true,
    hasAccountForService: true,
    account: foundAccount,
    role: foundRole,
    fromBanzaiService: false,
  };
}
